export enum HierarchyType {
  HOME = 'Home',
  PROPERTY = 'Property',
}

export interface BlockReason {
  description: string
  hierarchy: HierarchyType
  id: number
}
